import * as ambassadorWixAgentsV1AgentDefinition from './agents-v1-agent-definition-agent-registry.http.js';
import * as ambassadorWixAgentsV1AgentDefinitionTypes from './agents-v1-agent-definition-agent-registry.types.js';
import * as ambassadorWixAgentsV1AgentDefinitionUniversalTypes from './agents-v1-agent-definition-agent-registry.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createAgentDefinition(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAgentsV1AgentDefinitionUniversalTypes.CreateAgentDefinitionRequest,
  ambassadorWixAgentsV1AgentDefinitionTypes.CreateAgentDefinitionRequest,
  ambassadorWixAgentsV1AgentDefinitionUniversalTypes.CreateAgentDefinitionResponse,
  ambassadorWixAgentsV1AgentDefinitionTypes.CreateAgentDefinitionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAgentsV1AgentDefinition.createAgentDefinition(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/agent-definitions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getAgentDefinition(): __PublicMethodMetaInfo<
  'GET',
  { agentDefinitionId: string },
  ambassadorWixAgentsV1AgentDefinitionUniversalTypes.GetAgentDefinitionRequest,
  ambassadorWixAgentsV1AgentDefinitionTypes.GetAgentDefinitionRequest,
  ambassadorWixAgentsV1AgentDefinitionUniversalTypes.GetAgentDefinitionResponse,
  ambassadorWixAgentsV1AgentDefinitionTypes.GetAgentDefinitionResponse
> {
  const payload = { agentDefinitionId: ':agentDefinitionId' } as any;

  const getRequestOptions =
    ambassadorWixAgentsV1AgentDefinition.getAgentDefinition(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/agent-definitions/{agentDefinitionId}',
    pathParams: { agentDefinitionId: 'agentDefinitionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateAgentDefinition(): __PublicMethodMetaInfo<
  'PATCH',
  { agentDefinitionId: string },
  ambassadorWixAgentsV1AgentDefinitionUniversalTypes.UpdateAgentDefinitionRequest,
  ambassadorWixAgentsV1AgentDefinitionTypes.UpdateAgentDefinitionRequest,
  ambassadorWixAgentsV1AgentDefinitionUniversalTypes.UpdateAgentDefinitionResponse,
  ambassadorWixAgentsV1AgentDefinitionTypes.UpdateAgentDefinitionResponse
> {
  const payload = { agentDefinition: { id: ':agentDefinitionId' } } as any;

  const getRequestOptions =
    ambassadorWixAgentsV1AgentDefinition.updateAgentDefinition(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/agent-definitions/{agentDefinition.id}',
    pathParams: { agentDefinitionId: 'agentDefinitionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteAgentDefinition(): __PublicMethodMetaInfo<
  'DELETE',
  { agentDefinitionId: string },
  ambassadorWixAgentsV1AgentDefinitionUniversalTypes.DeleteAgentDefinitionRequest,
  ambassadorWixAgentsV1AgentDefinitionTypes.DeleteAgentDefinitionRequest,
  ambassadorWixAgentsV1AgentDefinitionUniversalTypes.DeleteAgentDefinitionResponse,
  ambassadorWixAgentsV1AgentDefinitionTypes.DeleteAgentDefinitionResponse
> {
  const payload = { agentDefinitionId: ':agentDefinitionId' } as any;

  const getRequestOptions =
    ambassadorWixAgentsV1AgentDefinition.deleteAgentDefinition(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/agent-definitions/{agentDefinitionId}',
    pathParams: { agentDefinitionId: 'agentDefinitionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryAgentDefinitions(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixAgentsV1AgentDefinitionUniversalTypes.QueryAgentDefinitionsRequest,
  ambassadorWixAgentsV1AgentDefinitionTypes.QueryAgentDefinitionsRequest,
  ambassadorWixAgentsV1AgentDefinitionUniversalTypes.QueryAgentDefinitionsResponse,
  ambassadorWixAgentsV1AgentDefinitionTypes.QueryAgentDefinitionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAgentsV1AgentDefinition.queryAgentDefinitions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/agent-definitions/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateAgentDefinitionTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAgentsV1AgentDefinitionUniversalTypes.BulkUpdateAgentDefinitionTagsRequest,
  ambassadorWixAgentsV1AgentDefinitionTypes.BulkUpdateAgentDefinitionTagsRequest,
  ambassadorWixAgentsV1AgentDefinitionUniversalTypes.BulkUpdateAgentDefinitionTagsResponse,
  ambassadorWixAgentsV1AgentDefinitionTypes.BulkUpdateAgentDefinitionTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAgentsV1AgentDefinition.bulkUpdateAgentDefinitionTags(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/agent-definitions/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateAgentDefinitionTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAgentsV1AgentDefinitionUniversalTypes.BulkUpdateAgentDefinitionTagsByFilterRequest,
  ambassadorWixAgentsV1AgentDefinitionTypes.BulkUpdateAgentDefinitionTagsByFilterRequest,
  ambassadorWixAgentsV1AgentDefinitionUniversalTypes.BulkUpdateAgentDefinitionTagsByFilterResponse,
  ambassadorWixAgentsV1AgentDefinitionTypes.BulkUpdateAgentDefinitionTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAgentsV1AgentDefinition.bulkUpdateAgentDefinitionTagsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/agent-definitions/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  AgentDefinition as AgentDefinitionOriginal,
  AgentStatus as AgentStatusOriginal,
  AgentStatusWithLiterals as AgentStatusWithLiteralsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  AgentDefinitionTagsModified as AgentDefinitionTagsModifiedOriginal,
  CreateAgentDefinitionRequest as CreateAgentDefinitionRequestOriginal,
  CreateAgentDefinitionResponse as CreateAgentDefinitionResponseOriginal,
  GetAgentDefinitionRequest as GetAgentDefinitionRequestOriginal,
  GetAgentDefinitionResponse as GetAgentDefinitionResponseOriginal,
  UpdateAgentDefinitionRequest as UpdateAgentDefinitionRequestOriginal,
  UpdateAgentDefinitionResponse as UpdateAgentDefinitionResponseOriginal,
  DeleteAgentDefinitionRequest as DeleteAgentDefinitionRequestOriginal,
  DeleteAgentDefinitionResponse as DeleteAgentDefinitionResponseOriginal,
  QueryAgentDefinitionsRequest as QueryAgentDefinitionsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryAgentDefinitionsResponse as QueryAgentDefinitionsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  BulkUpdateAgentDefinitionTagsRequest as BulkUpdateAgentDefinitionTagsRequestOriginal,
  BulkUpdateAgentDefinitionTagsResponse as BulkUpdateAgentDefinitionTagsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkUpdateAgentDefinitionTagsResult as BulkUpdateAgentDefinitionTagsResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateAgentDefinitionTagsByFilterRequest as BulkUpdateAgentDefinitionTagsByFilterRequestOriginal,
  BulkUpdateAgentDefinitionTagsByFilterResponse as BulkUpdateAgentDefinitionTagsByFilterResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  BulkUpdateAgentDefinitionTagsApplicationErrors as BulkUpdateAgentDefinitionTagsApplicationErrorsOriginal,
  BulkUpdateAgentDefinitionTagsByFilterApplicationErrors as BulkUpdateAgentDefinitionTagsByFilterApplicationErrorsOriginal,
} from './agents-v1-agent-definition-agent-registry.types.js';
